export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative flex flex-col md:flex-row rounded-3xl bg-foreground-900 overflow-hidden">
          <div className="md:w-2/5 relative min-h-[280px] md:min-h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20woman%20in%20modern%20cream%20blazer%20working%20at%20minimal%20desk%20with%20laptop%2C%20confident%20expression%2C%20warm%20studio%20lighting%2C%20clean%20contemporary%20office%20background%2C%20editorial%20portrait%20style%2C%20no%20text&width=600&height=800&seq=testimonial-v2-2026&orientation=portrait"
              alt="acbuyspreadsheet testimonial"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="md:w-3/5 flex flex-col justify-center p-8 md:p-12">
            <i className="ri-double-quotes-l text-4xl text-accent-400"></i>
            <p className="mt-4 text-lg md:text-xl text-background-50 leading-relaxed font-medium">
              &ldquo;acbuyspreadsheet completely streamlined our buying process. The data comparison is instant and the workflow is unmatched. We have never made smarter purchasing decisions.&rdquo;
            </p>
            <div className="mt-6">
              <p className="text-background-100 font-semibold text-sm">Sarah Mitchell</p>
              <p className="text-background-300 text-xs">E-commerce Operations Manager</p>
            </div>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap self-start"
            >
              See the Results
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}